<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-card class="box no-display">
            <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title>
                    <strong> Leaving Certificate </strong>
                    <v-icon @click="onload" title="Reload list" dark color="yellow">mdi-reload</v-icon>
                </v-toolbar-title>
            </v-toolbar>
            <v-row justify="center">
                <v-col cols="12" sm="4" md="4" class="mt-3">
                    <v-combobox class="no-display" v-model="registration_no" @change="checkHistory" :loading="comp_load"
                        rounded :items="stud_list" label="Select Student" item-text="name" outlined dense
                        prepend-icon="mdi-account-child-circle"></v-combobox>
                </v-col>
            </v-row>
            <div v-if="registration_no != null">
                <template>
                    <v-expansion-panels class="expapanel no-display mb-6" focusable inset>
                        <v-expansion-panel>
                            <v-expansion-panel-header class="panelheader">Account History </v-expansion-panel-header>
                            <v-expansion-panel-content class="mt-5">
                                <v-data-table :headers="headers_1" :items="ay_record" class="elevation-1 mytable" dense>
                                    <template v-slot:item.status="{ item }">
                                        <v-chip :color="getColor(item.status)" dark>
                                            {{ item.status }}
                                        </v-chip>
                                    </template>
                                </v-data-table>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>
                    <v-expansion-panels class="expapanel no-display" focusable inset>
                        <v-expansion-panel>
                            <v-expansion-panel-header class="panelheader">Academic History </v-expansion-panel-header>
                            <v-expansion-panel-content class="mt-5">
                                <v-data-table :headers="headers_2" :items="ay_record_div" dense
                                    class="elevation-1 mytable"> </v-data-table>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </template>

                <v-row justify="center" dense class="no-display">
                    <v-radio-group v-model="fetch_gen_toggle" mandatory row class="radiobtn">
                        <v-radio label="Fetch LC" value="FETCH"></v-radio>
                        <v-radio label="Generate LC" value="GENERATE"></v-radio>
                    </v-radio-group>
                </v-row>
                <v-row justify="center" v-if="ay_record.length != 0">
                    <div class="fees no-display">
                        <span v-if="account_status" style="color: #4caf50;">Fees Clear </span>
                        <span v-else style="color: #f44336;">Fees Pending</span>
                    </div>
                </v-row>
            </div>
        </v-card>
        <div v-if="registration_no != null">
            <template class="no-display" v-if="fetch_gen_toggle == 'GENERATE'">
                <v-row justify="center" class="mt-3">
                    <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition"
                        offset-y max-width="290px" min-width="290px">
                        <template v-slot:activator="{ on }">
                            <v-text-field dense v-model="last_date_of_school"
                                @blur="date = parseDate(last_date_of_school)" v-on="on" hint="Last Date of Leaving"
                                prepend-icon="event" persistent-hint></v-text-field>
                        </template>
                        <v-date-picker v-model="date" no-title @input="menu1 = false"></v-date-picker>
                    </v-menu>

                    <v-menu ref="menu2" v-model="menu2" :close-on-content-click="false" transition="scale-transition"
                        offset-y max-width="290px" min-width="290px">
                        <template v-slot:activator="{ on }">
                            <v-text-field dense v-model="gen_date" @blur="date = parseDate(gen_date)" v-on="on"
                                hint="Generation Date" prepend-icon="event" persistent-hint></v-text-field>
                        </template>
                        <v-date-picker v-model="date2" no-title @input="menu2 = false"></v-date-picker>
                    </v-menu>

                    <v-menu ref="menu4" v-model="menu4" :close-on-content-click="false" transition="scale-transition"
                        offset-y max-width="290px" min-width="290px">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field v-bind="attrs" dense v-model="application_date"
                                @blur="date = parseDate(application_date)" v-on="on" hint="Date Of Application"
                                prepend-icon="event" persistent-hint></v-text-field>
                        </template>
                        <v-date-picker v-model="date_of_application" no-title @input="menu4 = false"
                            @change="setToText()"></v-date-picker>
                    </v-menu>
                    <v-menu ref="menu3" v-model="menu3" :close-on-content-click="false" transition="scale-transition"
                        offset-y max-width="290px" min-width="290px">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field v-bind="attrs" dense v-model="issue_date" @blur="date = parseDate(issue_date)"
                                v-on="on" hint="Date Of Issue" prepend-icon="event" persistent-hint></v-text-field>
                        </template>
                        <v-date-picker label="Issue Date" v-model="date_of_issue" no-title @input="menu3 = false"
                            @change="setToText2()"></v-date-picker>
                    </v-menu>
                </v-row>
                <v-row justify="center" class="mt-3">
                    <v-col cols="12" sm="3" md="3">
                        <v-combobox v-model="progress" rounded :items="dvt_prog" label="Select Progress" outlined dense
                            persistent-hint></v-combobox>
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <v-combobox v-model="conduct" rounded :items="dvt_conduct" label="Select Conduct" outlined dense
                            persistent-hint></v-combobox>
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <v-combobox v-model="remark" rounded :items="dvt_remark" label="Select Remark" outlined dense
                            persistent-hint></v-combobox>
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <v-combobox v-model="reason" rounded :items="dvt_reason" label="Select Reason" outlined dense
                            persistent-hint></v-combobox>
                    </v-col>
                </v-row>
                <v-row justify="center" class="mt-3">
                    <v-checkbox color="#0f2027" v-model="mark_inactive"
                        label="Do You Want To Mark Student Inactive After Generating LC.?"></v-checkbox>
                </v-row>
                <v-row justify="center">
                    <v-btn @click="genLC" :disabled="!condition">Generate LC</v-btn>
                </v-row>
            </template>
            <template class="no-display" v-if="fetch_gen_toggle == 'FETCH'">
                <v-btn class="button no-display" @click="fetchLC">Fetch LC</v-btn>

                <br />
            </template>
            <div id="document1" class="printdiv" v-if="lc_data != null">
                <v-row dense justify="center">
                    <div class="col-2 ">
                        <img :src="org_basic_data.school_logo" alt="" class="schlImg" />
                    </div>
                    <div class="col-9 " style="line-height: 190%;">
                        <center>
                            <h2 class="trust-name">TMV's</h2>
                            <h1 class="schl-name">{{ org_basic_data.school_name }}</h1>
                            <h4>{{ org_basic_data.address }}</h4>
                            <h4>(Affiliated to CBSE Delhi, Affiliation No. {{ org_basic_data.cbsc_no }}, School No. {{
                                org_basic_data.school_no }})</h4>
                            <h4><span> Tel. : {{ org_basic_data.phone }} </span>
                                <span style="margin-left: 5px;">
                                    Email: {{ org_basic_data.email }}
                                </span>
                            </h4>
                            <h2 class="lcheading"> School Leaving Certificate</h2>
                            <h4 class="mt-2">
                                (According to rule No. 17 of grant aid code) School Reg.No. 4022 / C.R. 96/SM-3
                                date:
                                27/04/2022
                            </h4>
                        </center>
                    </div>
                </v-row>
                <hr class="hr-tag" />
                <div class="lcdata">
                    <div class="row">
                        <div class="col-4">
                            <b><span>UDISE No. : </span>
                                <span v-if="lc_data.udise_no !== null && lc_data.udise_no !== ''">{{ lc_data.udise_no
                                    }}</span></b>
                        </div>
                        <div class="col-4">
                            <span><b>CBSE BOARD</b></span>
                        </div>
                        <div class="col-4">
                            <b> <span>General Reg. No. </span>
                                <span class="dashed-underline" style="width: 154px;"><span
                                        v-if="lc_data.gr_number !== null && lc_data.gr_number !== ''">{{
                                            lc_data.gr_number
                                        }}</span>
                                    <span v-else style="font-weight:bold">----</span>
                                </span></b>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-4">
                            <span>Student's PEN NO. </span>
                            <span class="dashed-underline" style="width: 138px;"><span
                                    v-if="lc_data.pen_no !== null && lc_data.pen_no !== ''">{{
                                        lc_data.pen_no
                                    }}</span>
                                <span v-else style="font-weight:bold">----</span>
                            </span>
                        </div>
                        <div class="col-7">
                            <span>Unique ID (Adhar Card No.) : </span>
                            <span class="dashed-underline" style="width: 174px;"><span
                                    v-if="lc_data.aadhar_no !== null && lc_data.aadhar_no !== ''">{{
                                        lc_data.aadhar_no
                                    }}</span>
                                <span v-else style="font-weight:bold">----</span>
                            </span>

                        </div>
                    </div>
                    <hr class="hr-tag" />
                    <div class="stud-info">
                        <v-row>
                            <v-col cols="12" sm="5" md="5">
                                <span><b>1.Name of Pupil in full:(Name) </b></span>
                                <span class="dashed-underline" style="width: 110px;"><span
                                        v-if="lc_data.first_name !== null && lc_data.first_name !== ''">{{
                                            lc_data.first_name
                                        }}</span>
                                    <span v-else style="font-weight:bold">----</span>
                                </span>
                            </v-col>
                            <v-col cols="12" sm="4" md="4">
                                <span><b>(Father's Name) </b></span>
                                <span class="dashed-underline" style="width: 160px;"><span
                                        v-if="lc_data.middle_name !== null && lc_data.middle_name !== ''">{{
                                            lc_data.middle_name
                                        }}</span>
                                    <span v-else style="font-weight:bold">----</span>
                                </span>
                            </v-col>

                            <v-col cols="12" sm="3" md="3">
                                <span><b>(Surname) </b></span>
                                <span class="dashed-underline" style="width: 129px;"><span
                                        v-if="lc_data.last_name !== null && lc_data.last_name !== ''">{{
                                            lc_data.last_name
                                        }}</span>
                                    <span v-else style="font-weight:bold">----</span>
                                </span>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" sm="12" md="12">
                                <span><b>2.Mother Name (in Full) : </b></span>
                                <span class="dashed-underline" style="width: 757px;"><span
                                        v-if="lc_data.mother_first_name !== null && lc_data.mother_first_name !== ''">{{
                                            lc_data.mother_first_name }}</span>
                                    <span v-else style="font-weight:bold">----</span>
                                </span>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" sm="6" md="6">
                                <span><b>3. Nationality : </b></span>
                                <span class="dashed-underline" style="width: 346px;"><span
                                        v-if="lc_data.nationality !== null && lc_data.nationality !== ''">{{
                                            lc_data.nationality
                                        }}</span>
                                    <span v-else style="font-weight:bold">----</span>
                                </span>
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                                <span><b> Mother Tongue : </b></span>
                                <span class="dashed-underline" style="width: 329px;"><span
                                        v-if="lc_data.mothertoungue !== null && lc_data.mothertoungue !== ''">{{
                                            lc_data.mothertoungue }}</span>
                                    <span v-else style="font-weight:bold">----</span>
                                </span>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" sm="3" md="3">
                                <span><b>4.Religion : </b></span>
                                <span class="dashed-underline" style="width: 122px;"><span
                                        v-if="lc_data.religion !== null && lc_data.religion !== ''">{{ lc_data.religion
                                        }}</span>
                                    <span v-else style="font-weight:bold">----</span>
                                </span>
                            </v-col>
                            <v-col cols="12" sm="5" md="5">
                                <span><b>Caste : </b></span>
                                <span class="dashed-underline" style="width: 331px;"><span
                                        v-if="lc_data.caste !== null && lc_data.caste !== ''">{{ lc_data.caste }}</span>
                                    <span v-else style="font-weight:bold">----</span>
                                </span>
                            </v-col>
                            <v-col cols="12" sm="4" md="4">
                                <span><b>Sub-Caste : </b></span>
                                <span class="dashed-underline" style="width: 205px;"><span
                                        v-if="lc_data.subcaste !== null && lc_data.subcaste !== ''">{{ lc_data.subcaste
                                        }}</span>
                                    <span v-else style="font-weight:bold">----</span>
                                </span>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" sm="4" md="4">
                                <span><b>5. Birth Place : </b></span>
                                <span class="dashed-underline" style="width: 175px;"><span
                                        v-if="lc_data.birth_place !== null && lc_data.birth_place !== ''">{{
                                            lc_data.birth_place
                                        }}</span>
                                    <span v-else style="font-weight:bold">----</span>
                                </span>
                            </v-col>
                            <v-col cols="12" sm="4" md="4">
                                <span><b>Tal : </b></span>
                                <span class="dashed-underline" style="width: 268px;"><span
                                        v-if="lc_data.birth_taluka !== null && lc_data.birth_taluka !== ''">{{
                                            lc_data.birth_taluka
                                        }}</span>
                                    <span v-else style="font-weight:bold">----</span>
                                </span>
                            </v-col>
                            <v-col cols="12" sm="4" md="4">
                                <span><b>Dist : </b></span>
                                <span class="dashed-underline" style="width: 261px;"><span
                                        v-if="lc_data.birth_district !== null && lc_data.birth_district !== ''">{{
                                            lc_data.birth_district }}</span>
                                    <span v-else style="font-weight:bold">----</span>
                                </span>
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                                <span style="padding-left: 17px;"><b>State : </b></span>
                                <span class="dashed-underline" style="width: 397px;"><span
                                        v-if="lc_data.birth_state !== null && lc_data.birth_state !== ''">{{
                                            lc_data.birth_state
                                        }}</span>
                                    <span v-else style="font-weight:bold">----</span>
                                </span>
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                                <span><b>Country : </b></span>
                                <span class="dashed-underline" style="width: 390px;"><span
                                        v-if="lc_data.birth_country !== null && lc_data.birth_country !== ''">{{
                                            lc_data.birth_country }}</span>
                                    <span v-else style="font-weight:bold">----</span>
                                </span>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" sm="12" md="12">
                                <span> <b>6. Date of Birth (in figure) : </b></span>
                                <span class="dashed-underline" style="width: 740px;"><span
                                        v-if="lc_data.dob_fig !== null && lc_data.dob_fig !== ''">{{ lc_data.dob_fig
                                        }}</span>
                                    <span v-else style="font-weight:bold">----</span>
                                </span>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" sm="12" md="12">
                                <span> <b>7. Date of Birth (in words) : </b></span>
                                <span class="dashed-underline" style="width: 738px;"><span
                                        v-if="lc_data.dob_words !== null && lc_data.dob_words !== ''">{{
                                            lc_data.dob_words
                                        }}</span>
                                    <span v-else style="font-weight:bold">----</span>
                                </span>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" sm="6" md="6">
                                <span> <b>8. Date of Admission : </b></span>
                                <span class="dashed-underline" style="width: 283px;"><span
                                        v-if="lc_data.doa !== null && lc_data.doa !== ''">{{ lc_data.doa }}</span>
                                    <span v-else style="font-weight:bold">----</span>
                                </span>
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                                <span> <b> Standard : </b></span>
                                <span class="dashed-underline" style="width: 378px;"><span
                                        v-if="lc_data.admittedstandard !== null && lc_data.admittedstandard !== ''">{{
                                            lc_data.admittedstandard }}</span>
                                    <span v-else style="font-weight:bold">----</span>
                                </span>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" sm="9" md="9">
                                <span> <b>9. Previous School Name : </b></span>
                                <span class="dashed-underline" style="width: 500px;"><span
                                        v-if="lc_data.last_school !== null && lc_data.last_school !== ''">{{
                                            lc_data.last_school
                                        }}</span>
                                    <span v-else style="font-weight:bold">----</span>
                                </span>
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                                <span> <b> Std : </b></span>
                                <span class="dashed-underline" style="width: 175px;"><span
                                        v-if="lc_data.previousschoolpassingstandard !== null && lc_data.previousschoolpassingstandard !== ''">{{
                                            lc_data.previousschoolpassingstandard }}</span>
                                    <span v-else style="font-weight:bold">----</span>
                                </span>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" sm="6" md="6">
                                <span> <b>10. Progress: </b></span>
                                <span class="dashed-underline" style="width: 363px;"><span
                                        v-if="lc_data.progress !== null && lc_data.progress !== ''">{{ lc_data.progress
                                        }}</span>
                                    <span v-else style="font-weight:bold">----</span>
                                </span>
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                                <span> <b> Conduct : </b></span>
                                <span class="dashed-underline" style="width: 382px;"><span
                                        v-if="lc_data.conduct !== null && lc_data.conduct !== ''">{{ lc_data.conduct
                                        }}</span>
                                    <span v-else style="font-weight:bold">----</span>
                                </span>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" sm="12" md="12">
                                <span><b>11. Date of School Leaving : </b></span>
                                <span class="dashed-underline" style="width: 732px;"><span
                                        v-if="lc_data.last_date_of_school !== null && lc_data.last_date_of_school !== ''">{{
                                            lc_data.last_date_of_school }}</span>
                                    <span v-else style="font-weight:bold">----</span>
                                </span>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" sm="12" md="12">
                                <span><b>12. Standard in which studying and since when: (in words) : </b></span>
                                <span class="dashed-underline" style="width: 448px;"><span
                                        v-if="lc_data.std_in_words !== null && lc_data.std_in_words !== ''">{{
                                            lc_data.std_in_words
                                        }}</span><span v-else style="font-weight: bold;">----</span> <span
                                        v-if="lc_data.standard_since_when !== null && lc_data.standard_since_when !== ''">(
                                        {{
                                        lc_data.standard_since_when }} )</span>
                                    <span v-else style="font-weight: bold;">----</span>
                                </span>

                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" sm="12" md="12">
                                <span><b>13. Standard in which studying and since when: (in figures) : </b></span>
                                <span class="dashed-underline" style="width: 444px;"><span
                                        v-if="lc_data.standard !== null && lc_data.standard !== ''">{{ lc_data.standard
                                        }}</span><span v-else style="font-weight: bold;">----</span> <span
                                        v-if="lc_data.standard_since_when !== null && lc_data.standard_since_when !== ''">(
                                        {{
                                        lc_data.standard_since_when }} )</span>
                                    <span v-else style="font-weight: bold;">----</span>
                                </span>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" sm="12" md="12">
                                <span><b>14. Reason of leaving school : </b></span>
                                <span class="dashed-underline" style="width: 725px;"><span
                                        v-if="lc_data.reason !== null && lc_data.reason !== ''">{{ lc_data.reason
                                        }}</span>
                                    <span v-else style="font-weight:bold">----</span>
                                </span>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" sm="12" md="12">
                                <span><b>15. Remark : </b></span>
                                <span class="dashed-underline" style="width: 861px;"><span
                                        v-if="lc_data.remark !== null && lc_data.remark !== ''">{{ lc_data.remark
                                        }}</span>
                                    <span v-else style="font-weight:bold">----</span>
                                </span>
                            </v-col>
                        </v-row>

                        <v-row dense>
                            <v-col cols="12" sm="11" md="11" class="ml-5">
                                <b>Certified that the above information is in accordance with School General
                                    Register No. 1.
                                </b>
                            </v-col>
                        </v-row>

                        <v-row dense>
                            <v-col cols="12" sm="9" md="9" class="ml-5">
                                <b>Certificate Issuing Date : {{ lc_data.gen_date }}</b>
                            </v-col>
                        </v-row>
                        <br />
                        <br />
                        <br />
                        <br />
                        <template>
                            <v-row class="text-center">
                                <v-col cols="4" align="center">
                                    <div style="border-top: 1px solid black; width: 80%;"></div><br>
                                    <strong>CLASS TEACHER</strong>
                                </v-col>
                                <v-col cols="4" align="center">
                                    <div style="border-top: 1px solid black; width: 80%;"></div><br>
                                    <strong>CLERK</strong>
                                </v-col>
                                <v-col cols="4" align="center">
                                    <div style="border-top: 1px solid black; width: 80%; "></div><br>
                                    <strong>PRINCIPAL</strong>
                                </v-col>
                            </v-row>

                            <div style="line-height: 180%;" class="">
                                <strong>Note:</strong>
                                <ol style="padding-left: 17px;">
                                    <li>Any changes in the school leaving certificate should be carried out in red ink
                                        with the initial of the head.</li>
                                    <li>Any infringement of this rule is liable to rustication or other suitable
                                        punishment.</li>
                                </ol>
                            </div>
                        </template>

                    </div>
                </div>
            </div>
            <!-- lc data code end -->

            <br />
            <div class="no-display" v-if="lc_data != null">
                <div class="no-display" style="text-align: center;">
                    ----------------------------------Modify------------------------------------
                </div>
                <br />
                <v-row class="no-display">
                    <v-col cols="12" sm="3" md="3">
                        <v-text-field label="Birth in words" v-model.trim="lc_data.dob_words"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <v-text-field label="Last School" v-model.trim="lc_data.last_school"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <v-text-field label="Standard" v-model.trim="lc_data.standard"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <v-text-field label="Since when..." v-model.trim="lc_data.standard_since_when"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <v-text-field label="Caste" v-model.trim="lc_data.caste"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <v-text-field label="Sub Caste" v-model.trim="lc_data.subcaste"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <v-text-field label="Religion" v-model.trim="lc_data.religion"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <v-text-field label="Birth District" v-model.trim="lc_data.birth_district"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <v-text-field label="Birth Taluka" v-model.trim="lc_data.birth_taluka"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <v-text-field label="Birth State" v-model.trim="lc_data.birth_state"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <v-text-field label="Birth Country" v-model.trim="lc_data.birth_country"></v-text-field>
                    </v-col>
                </v-row>
                <center>
                    <v-btn @click="printPage" class="info">Proceed to print</v-btn>
                </center>
            </div>
        </div>
    </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
    data() {
        return {
            mark_inactive: false,
            headers_1: [
                { text: "Academic Year", value: "ay" },
                { text: "Paid", value: "paid" },
                { text: "Balance", value: "balance" },
                { text: "Status", value: "status" },
            ],
            headers_2: [
                { text: "Academic Year", value: "ay" },
                { text: "Roll No", value: "rollno" },
                { text: "Div", value: "div" },
                { text: "Std", value: "std" },
                { text: "Total", value: "total" },
                { text: "Present ", value: "present" },
            ],

            comp_load: false,
            fetch_loader: false,
            overlay: false,
            snackbar: false,
            snackbar_msg: "",
            color: "",
            snackbar: false,
            registration_no: null,
            stud_list: [],
            ay_record: [],
            ay_record_div: [],
            account_status: false,
            dvt_prog: [],
            progress: null,
            dvt_conduct: [],
            conduct: null,
            dvt_reason: [],
            reason: null,
            dvt_remark: [],
            remark: null,
            fetch_gen_toggle: "FETCH",
            last_date_of_school: "",
            gen_date: "",
            application_date: "",
            issue_date: "",
            date_of_application: new Date().toISOString().substr(0, 10),
            date_of_issue: new Date().toISOString().substr(0, 10),
            date: new Date().toISOString().substr(0, 10),
            date2: new Date().toISOString().substr(0, 10),
            menu1: false,
            menu2: false,
            menu3: false,
            menu4: false,
            nowDate: new Date().toISOString().slice(0, 10),
            lc_data: null,
            org_basic_data: null,
            condition: false,
        };
    },
    watch: {
        date(val) {
            this.last_date_of_school = this.formatDate(this.date);
        },
        date2(val) {
            this.gen_date = this.formatDate(this.date2);
        },
        date_of_application(val) {
            this.application_date = this.formatDate(this.date_of_application);
            this.lc_data.date_of_application = this.application_date;
        },
        date_of_issue(val) {
            this.issue_date = this.formatDate(this.date_of_issue);
            this.lc_data.date_of_issue = this.issue_date;
        },
    },
    methods: {
        printPage() {
            var content = document.getElementById("document1").innerHTML;
            var mywindow = document.body.innerHTML;
            document.body.innerHTML = content;
            window.print();
            document.body.innerHTML = mywindow;
            location.reload();
            return true;
        },
        setToText() {
            this.lc_data.date_of_application = this.application_date;
        },
        setToText2() {
            this.lc_data.date_of_issue = this.issue_date;
        },
        proceed() {
            window.print();
            // localStorage.setItem("lc_data", JSON.stringify(this.lc_data));
            // localStorage.setItem("org_basic_data", JSON.stringify(this.org_basic_data));
            // let routeData = this.$router.resolve({ name: "tmv-lc-print" });
            // window.open(routeData.href, "_blank");
        },

        formatDate(date) {
            if (!date) return null;
            const [year, month, day] = date.split("-");
            return `${day}-${month}-${year}`;
        },

        getColor(status) {
            if (status === "pending") return "red";
            if (status === "clear") return "green";
            if (status === "NA") return "gray";
        },

        print() {
            this.$store.state.drawer = false;
            let that = this;
            window.onafterprint = function () {
                that.$store.state.drawer = true;
            };
            setTimeout(function () {
                window.print();
            }, 100);
        },

        parseDate(date) {
            if (!date) return null;
            const [month, day, year] = date.split("/");
            return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
        onerror(error) {
            let msg = "";
            if (error.response) {
                msg = "Something went wrong.";
            } else if (error.request) {
                msg = "Please try again.";
            } else {
                msg = "Un-expected error.";
            }
            this.showSnackbar("error", msg);
        },
        onload() {
            this.ay_record = [];
            this.lc_data = null;
            this.org_basic_data = null;
            this.comp_load = true;
            axios
                .post("/admission/getAllStudents")
                .then((res) => {
                    if (res.data.msg == "200") {
                        this.stud_list = res.data.all_stud_list;
                    } else {
                        this.showSnackbar("red", "Something went wrong.");
                    }
                    this.comp_load = false;
                })
                .catch((error) => {
                    this.onerror(error);
                    this.comp_load = false;
                })
                .finally(() => {
                    this.comp_load = false;
                });
        },
        checkHistory() {
            console.log("registration_no:", this.registration_no);
            this.ay_record = [];
            this.lc_data = null;
            this.org_basic_data = null;
            if (this.registration_no == null) {
                this.showSnackbar("red", "Please select student");
            }
            this.overlay = true;
            axios
                .post("/certificate/checkHistory", this.registration_no)
                .then((res) => {
                    console.log("res", res.data);
                    if (res.data.flag == "YES") {
                        this.ay_record = res.data.ay_record;
                        this.account_status = res.data.account_status;
                        this.ay_record_div = res.data.ay_record_div;
                        this.dvt_prog = res.data.dvt_prog;
                        this.progress = this.dvt_prog[0];
                        this.dvt_conduct = res.data.dvt_conduct;
                        this.conduct = this.dvt_conduct[0];
                        this.dvt_reason = res.data.dvt_reason;
                        this.reason = this.dvt_reason[0];
                        this.dvt_remark = res.data.dvt_remark;
                        this.remark = this.dvt_remark[0];
                        this.condition = res.data.condition;
                        if (!this.condition) this.showSnackbar("red", res.data.condition_msg);
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                    }
                    this.overlay = false;
                })
                .catch((error) => {
                    this.onerror(error);
                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
        genLC() {
            if (this.account_status == false) {
                if (!confirm("Are You Sure You Want To generate LC as fees is pending...?")) return;
            }
            if (this.progress != null && this.conduct != null && this.last_date_of_school != "" && this.gen_date != "" && this.remark != null && this.reason != null && this.application_date != "" &&
                this.issue_date != "") {
                const formData = {
                    lid: this.registration_no.lid,
                    progress: this.progress,
                    conduct: this.conduct,
                    remark: this.remark,
                    reason: this.reason,
                    last_date_of_school: this.last_date_of_school,
                    gen_date: this.gen_date,
                    date_of_application: this.application_date,
                    date_of_issue: this.issue_date,
                    mark_inactive: this.mark_inactive,
                };
                this.overlay = true;
                axios
                    .post("/certificate/genLC", formData)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.org_basic_data = res.data.org_basic_data;
                            this.lc_data = res.data.lc_data;
                        } else {
                            this.showSnackbar("red", res.data.snackbar);
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                        this.overlay = false;
                    })
                    .catch((error) => {
                        this.onerror(error);

                        this.overlay = false;
                    })
                    .finally(() => {
                        this.overlay = false;
                    });
            } else {
                this.showSnackbar("red", "Please select/enter all data");
            }
        },
        fetchLC() {
            this.overlay = true;
            axios
                .post("/certificate/fetchLC", this.registration_no)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.org_basic_data = res.data.org_basic_data;
                        this.lc_data = res.data.lc_data;
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.overlay = false;
                })
                .catch((error) => {
                    this.onerror(error);
                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
    },
    mounted() {
        localStorage.setItem("lc_data", null);
        localStorage.setItem("org_basic_data", null);
        localStorage.setItem("last_date_of_school", "");
        this.onload();
        this.last_date_of_school = this.formatDate(this.date);
        this.gen_date = this.formatDate(this.date2);
        this.application_date = this.formatDate(this.date_of_application);
        this.issue_date = this.formatDate(this.date_of_issue);
    },
};
</script>
<style scoped>
.mytable1 /deep/ thead th {
    background: #0f2027 !important;
    background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important;
    background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important;
    background-color: #0f2027 !important;
    color: white !important;
    font-weight: bold !important;
    white-space: nowrap !important;
    text-align: center;
}

.mytable /deep/ thead th {
    background-color: #0f2027 !important;
    color: white !important;
    font-weight: bold !important;
    white-space: nowrap !important;
    text-align: center;
    background: #83a4d4;
    background: -webkit-linear-gradient(to right, #265fb1, #b6fbff);
    background: linear-gradient(to right, #265fb1, #b6fbff);
}

tr,
td,
th {
    border: 1px solid #ccc;
    text-align: center;
    font-size: small;
}

tr,
tbody {
    border-bottom: 1px solid #ccc;
    border: 1px solid #ccc;
    font-size: small;
}

td {
    margin: 0.3rem !important;
    padding: 0.4rem !important;
    font-size: small;
}

.lcdata {
    padding: 0px 20px;
}

.dashed-underline {
    border-bottom: 1px solid;
    display: inline-block;
    padding-bottom: 3px;
    /* line-height: 1.2rem; */
}

.expapanel {
    width: 93%;
    margin-left: 3%;
}

.panelheader {
    color: white !important;
    background: #83a4d4;
    /* fallback for old browsers */
    background: -webkit-linear-gradient(to right, #3792c7, #60e3eb, #a0dfe3);
    /* Chrome 10-25, Safari 5.1-6 */
    font-size: 16px;
    background: linear-gradient(to right, #3792c7, #60e3eb, #a0dfe3);
}

.printdiv {
    margin-left: 19%;
    margin-right: 19%;
    background-color: white;
}

.trust-name {
    color: #df1f28;
    font-family: 'Times New Roman', Times, serif;
}

.schl-name {
    text-transform: uppercase;
    color: #035a8f;
    font-family: 'Times New Roman', Times, serif;
}

.schlImg {
    margin-left: 10%;
}

.lcheading {
    width: 64%;
    border-radius: 17px;
    border: 1px solid black;
    color: #df1f28;
    text-transform: uppercase;
    margin-top: 10px;
    font-style: italic;
}

.hr-tag {
    height: 1px;
    border-width: 0px;
    background-color: black;
    width: 100%;
    margin-bottom: 4px;
}

.underline {
    border-bottom: 1px solid;
}

.schlImg {
    width: 180px;
    height: 180px;
    margin-left: 30px;
}

.tdata2 {
    font-weight: bolder;
}

#page tr,
td {
    font-size: large;
    text-align: left;
}

@media print {
    .no-display {
        display: none !important;
    }

    .lcdata {
        padding: 0px 20px;
        font-size: 21px !important;
        line-height: 110%;
    }
}
</style>
